import { tableFromIPC } from "@uwdata/flechette";
import { sortBy } from "lodash";
import { useState, useEffect } from "react";
import {
  parseArrowToTimeSeries,
  parseArrowToSOCTimeSeries,
  generateCommonTimeline,
  extrapolateToTimeseries,
} from "../Components/dataUtils";
import { TimeSeries } from "../Charts/TimeSeriesChart";

type BessTimeSeries = {
  powerTimeSeries: TimeSeries[] | undefined;
  socTimeSeries: TimeSeries[] | undefined;
};

export const useMapBessResponseToTimeseries = (
  data: Response,
): BessTimeSeries => {
  const [powerTimeSeries, setPowerTimeSeries] = useState<TimeSeries[]>();
  const [socTimeSeries, setSOCTimeSeries] = useState<TimeSeries[]>();

  useEffect(() => {
    async function fetchData() {
      if (!data) {
        return;
      }
      const arrayBuffer = await (data as Response).arrayBuffer();
      const table = tableFromIPC(arrayBuffer, { useProxy: true }).toArray();

      const parsedPower = parseArrowToTimeSeries(table);
      const powerTimeline = generateCommonTimeline(parsedPower);
      setPowerTimeSeries(
        sortBy(
          parsedPower.map((s) => extrapolateToTimeseries(s, powerTimeline)),
          "name",
        ),
      );

      const parsedSOC = parseArrowToSOCTimeSeries(table);
      if (parsedSOC.length > 0) {
        const socTimeline = generateCommonTimeline(parsedSOC);
        setSOCTimeSeries(
          sortBy(
            parsedSOC.map((s) => extrapolateToTimeseries(s, socTimeline)),
            "name",
          ),
        );
      }
    }
    fetchData();
  }, [data]);

  return { powerTimeSeries, socTimeSeries };
};
